import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5s2dmkfdd: FaireProductEntity = {
  token: "p_q5s2dmkfdd",
  type: "product",
  name: "Flower Market Aromatherapy Roller - Sleep 10 ml",
  brandName: "123 Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/79a1a8e93a1ca0ffe405cfb34d9271f0227465f040f81d6bc5705bddc11efc64.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a4993b4dbfb17de94b2291d13c4bd5efcd68f0f113ab6456602b31be53db0414.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
